export default __webpack_public_path__ + "static/media/github-icon.914e2817.svg";